import {  X
} from 'lucide-react';

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
      <div className="bg-white w-full max-w-3xl max-h-[85vh] rounded-3xl shadow-2xl z-10 flex flex-col overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="flex justify-between items-center p-6 border-b border-slate-100 bg-slate-50/50">
          <h2 className="text-xl font-black text-slate-900 tracking-tight">{title}</h2>
          <button onClick={onClose} className="p-2 bg-white rounded-full hover:bg-rose-50 hover:text-rose-600 text-slate-400 shadow-sm transition-colors border border-slate-200">
            <X size={20} strokeWidth={2.5} />
          </button>
        </div>
        <div className="p-6 overflow-y-auto bg-white flex-1">
          {children}
        </div>
      </div>
    </div>
  );
};
export default Modal;